import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import * as moment from 'moment';

import { environment } from './../../../environments/environment.prod';

import { Auth } from '../../autentication/Auth';

import { PaymentFederalTaxes } from './models/payment-federal-taxes';
import { CodePay } from './models/code-pay';
import { Limit } from '../limits/models/limits';
import { FormatPricePipe } from '../../shared/format-price.pipe';
import { endpoints } from '../../../environments/environment';
import { AccountNumberPipe } from '../../shared/account-number.pipe';

@Injectable()
export class PaymentFederalTaxesService {

	paymentCodes: Array<CodePay>;

	limits: Array<Limit>;

	constructor(private http: HttpClient) { }

	confirmation(payment: PaymentFederalTaxes): Observable<any> {

		return this.http.post( environment.apiUrl + `pagamento/${payment.typeTax.toUpperCase()}/${payment.payID}/confirmacao`, {});

	}

	// TODO POST /contas/senha/transacao/valida
	passwordValidate(payment: PaymentFederalTaxes): Observable<any> {
		const paymentData = {
			senha: payment.password
		};

		// return this.http.post( environment.apiUrl + 'contas/senha/transacao/valida', paymentData );
		return this.http.post( endpoints.accounts.validateTransactionPassword, paymentData );
	}


	// GPS
	sendPaymentGPS(payment: PaymentFederalTaxes): Observable<any> {

		const accNumPipe = new AccountNumberPipe();

		const paymentData = {
			CodAgenciaOrigem: Auth.getInstance().getUser().agency,
			CodContaOrigem: accNumPipe.transform(Auth.getInstance().getUser().accountNumber),
			Complemento: '',
			CodPagamento: payment.codePayObject.code,
			MesCompetencia: payment.competenceMonth,
			AnoCompetencia: payment.competenceYear,
			TipoIdentificador: payment.identifierType,
			Identificador: payment.identifier,
			NomeContribuinte: payment.taxpayerName,
			ValorINSS: payment.valueINSS,
			ValorOutraEntidade: payment.valueOthers,
			DataAgendamento: payment.date,
			CPFSolicitante: Auth.getInstance().getUser().cpf
		};

		return this.http.post( environment.apiUrl + 'pagamento/GPS', paymentData );

	}

	getCodePay(typeTax: String): Observable<CodePay[]> {

		return this.http.get( environment.apiUrl + 'pagamento/codigos/' +
			Auth.getInstance().getUser().agency + '/' +
			Auth.getInstance().getUser().accountNumber + '/' +
			typeTax).pipe(map((data: any) => {

				if (data.Sucesso) {

					this.paymentCodes = data.Retorno.map(item => {
						const codePay = new CodePay();
						codePay.code = item.Codigo;
						codePay.description = item.Descricao;
						codePay.idreqRef = item.IDReqRef;
						codePay.label = codePay.code + ' - ' + codePay.description;

						return codePay;
					});

				}

				return this.paymentCodes;

			}));

	}


	// DARF
	sendPaymentDARF(payment: PaymentFederalTaxes): Observable<any> {

		const accNumPipe = new AccountNumberPipe();

		const paymentData = {
			CodAgenciaOrigem: Auth.getInstance().getUser().agency,
			CodContaOrigem: accNumPipe.transform(Auth.getInstance().getUser().accountNumber),
			Complemento: '',
			DataReferencia: payment.refDate,
			DataVencimento: payment.expDate,
			CodReceita: payment.recipeCod,
			NroReferencia:  payment.refNumber,
			ValorPrincipal: payment.valueDefault,
			ValorJuros: payment.valueTax,
			ValorMulta: payment.valueTicket,
			DataAgendamento: payment.date,
			CPFSolicitante: Auth.getInstance().getUser().cpf
		};

		return this.http.post( environment.apiUrl + 'pagamento/DARF', paymentData ).pipe( map( (data: any) => {

			return data;

		}));

	}

	getDataLimits(): Observable<any[]> {

		const sendData = {
			agencia: Auth.getInstance().getUser().agency,
			conta: Auth.getInstance().getUser().accountNumber
		};

		return this.http.post( environment.apiUrl + 'contas/limites', sendData ).pipe(map((data: any) => {

			if (data.Sucesso) {

				this.limits = data.Retorno.Limite.map(item => {
					// if (item.TipoLimite === 'DARF' || item.TipoLimite === 'GPS') {
					if (item.TipoLimite === 'DARF') {
							const limit = new Limit();
							const FP = new FormatPricePipe();

							limit.typeLimit = item.TipoLimite;

							if (item.Tarifa || item.Tarifa > 0) {
								limit.fee = FP.transform(item.Tarifa, false);
							} else {
								limit.fee = 'Gratuito';
							}

							limit.timeStart = item.HorarioInicio + 'h';

							limit.timeLimit = item.HorarioLimite + 'h';

							if (item.PrazoCompensacao === 1) {
								limit.compensationDate = 'Mesmo dia*';
							} else if (item.PrazoCompensacao === 2) {
								limit.compensationDate = 'Próximo dia útil*';
							}	else {
								limit.compensationDate = item.PrazoCompensacao + ' dias úteis';
							}

						return limit;
					}
				});

			}

			return this.limits;
		}));
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-federal-taxes.service.ts